<template lang="pug">
  section.parallax-image__scroll
    .parallax-image__wrapper
      .container
        .parallax-image.row(data-rellax="" :data-rellax-speed="parallaxFirstImage" )
          .col-9(class="md:col-7")
            slot(name="first-image")
        .parallax-image.row.justify-end(data-rellax="" :data-rellax-speed="parallaxSecondImage")
          .col-9(class="md:col-7")
            slot(name="second-image")

      .parallax-image__title(:class="classAnimation")
        .container
          slot(name="title")
</template>

<script>
import Rellax from 'rellax'

export default {
  props: {
    begin: {
      type: Number,
      default: 0
    },

    end: {
      type: Number,
      default: 100
    },

    parallaxFirstImage: {
      type: Number,
      default: 2
    },
    parallaxSecondImage: {
      type: Number,
      default: 3
    }
  },

  data () {
    return {
      blocHeight: 0,
      blocOffset: 0,
      titlePosition: 0,
      classAnimation: 'opacity-0 invisible'
    }
  },

  computed: {
    // Return current title y position in %
    titlePositionPourcent () {
      const calc = Math.round(100 * this.titlePosition / this.blocHeight)

      return calc > 0 ? calc : 0
    }
  },

  mounted () {
    document.addEventListener('scroll', this.titlePositionCalcHandler)
    // FIX BUG RELOAD IN MIDDLE PAGE RELLAX : https://github.com/dixonandmoe/rellax/issues/52
    window.onload = function () {
      new Rellax('[data-rellax]', {
        center: true
      })
    }
  },
  methods: {
    titlePositionCalcHandler () {
      // height bloc parallax image section
      this.blocHeight = this.$el.clientHeight

      // position from top window
      this.blocOffset = this.$el.offsetTop

      // position title in px from top section
      this.titlePosition = (window.scrollY + window.innerHeight / 2) - this.blocOffset

      // Change visible class animation between begin prop & end prop
      if (this.titlePositionPourcent > this.begin && this.titlePositionPourcent < this.end) {
        this.classAnimation = 'opacity-100 visible'
      } else {
        this.classAnimation = 'opacity-0 invisible'
      }
    }
  }
}
</script>
